import { ACTION_TYPE } from '../../store/actionCreatorsHelpers';

export function openUrl(appId: string, name: string, url: string) {
    return {
        type: ACTION_TYPE.OPEN_URL,
        appId,
        name,
        url,
    };
}
export function closeUrl() {
    return {
        type: ACTION_TYPE.CLOSE_URL,
    };
}
